// extracted by mini-css-extract-plugin
export default {"formSettings":"GsdjSWb7OLhMyvEYvCjj","formSettingsItem":"Q_eE244n7ems5xlnP0yE","tooltip":"mG0RWvLaPfRRij4m8Jbs","signingOrderField":"MLpg5KNAMFweYbTjM8PU"};